import { render, staticRenderFns } from "./AssigneeSelector.vue?vue&type=template&id=75b0639a&"
import script from "./AssigneeSelector.vue?vue&type=script&lang=ts&"
export * from "./AssigneeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AssigneeSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports